/**
 * interact.js v1.3.2
 *
 * Copyright (c) 2012-2017 Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
